import React, { createContext, useContext, useMemo } from 'react';
import { getBACNumberFromJWT, goToLoginPage, isCSR, isCustomerLoggedIn } from '@raisin/cp-utils';
export const AuthContext = createContext({
    canAccess: true,
    isAuthRequired: false,
    isLoggedIn: false,
});
export const useAuthContext = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuthContext must be used within a AuthProvider');
    }
    return context;
};
export const AuthProvider = ({ isAuthRequired = false, isBypassContext = true, fallback = null, children, }) => {
    const customerId = useMemo(() => (isCSR() && isCustomerLoggedIn() ? getBACNumberFromJWT() : null), []);
    const canAccess = customerId != null || isBypassContext || !isAuthRequired;
    if (isCSR() && !canAccess) {
        goToLoginPage();
    }
    const authContextValue = useMemo(() => ({
        canAccess,
        isLoggedIn: !!customerId,
        customerId,
        isAuthRequired,
    }), [canAccess, customerId, isAuthRequired]);
    return (React.createElement(AuthContext.Provider, { value: authContextValue }, canAccess ? children : fallback));
};
//# sourceMappingURL=auth.js.map